import { Controller } from 'stimulus';

export default class extends Controller {
  static values = { url: String }

  connect() {
    $.ajax(this.urlValue, 'script');
  }
}
